import useGetIdTokenHint from '@/api/fetch-user-token-hint';
import useFetchUserOrganizations from '@/api/use-fetch-user-organizations';
import { NavigationItems } from "@/components/NavigationItems";
import { Main } from '@/Main';
import { Shell } from "@digital-services/shell";
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from 'react-router';
import { ErrorBoundary } from 'react-error-boundary';

import i18nInstance from "../i18n";
import { useIsAuthorized } from './hooks/use-is-authorized';

import '../../../node_modules/@destination/components/dist/index.css';
import '../../../node_modules/@digital-services/shell/dist/index.css';
import './index.css';
import { GeneralFallback } from './pages/Error/GeneralFallback';

const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

const clientId: string = import.meta.env.VITE_APP_CLIENT_ID;
const authority: string = import.meta.env.VITE_APP_AUTHORITY;

const authConfig = {
  authority: authority,
  clientId: clientId
};

const sidebar = {
  navItems: (
    <I18nextProvider i18n={i18nInstance}>
      <NavigationItems />
    </I18nextProvider>
  )
}

const App = () => {
  const getUserOrganizations = useFetchUserOrganizations();
  const isAuthorized = useIsAuthorized();
  const getIdTokenHint = useGetIdTokenHint();

  return (
    <ErrorBoundary FallbackComponent={GeneralFallback}>
      <BrowserRouter>
        <Shell
          auth={{
            config: authConfig,
            getUserOrganizations,
            isAuthorized,
            getIdTokenHint
          }}
          applicationName="Factory Process Service"
          alwaysMobile={false}
          sidebar={sidebar}
        >
          <Main />
        </Shell>
      </BrowserRouter>
    </ErrorBoundary>
  );
};

root.render(<App />);
